// Centralized access control configuration
// This is the single source of truth for role-based access

// Role assignments - who has what role
// - admin: has access to all boards/pods, except Dev category
// - dev: has access to everything, power to edit daily apps and impersonate
export const ROLE_ASSIGNMENTS: Record<string, string[]> = {
  admin: [
    "chris@mavenmm.com",
    "dave@mavenmm.com",
    "kris@mavenmm.com",
    "samanda@mavenmm.com",
  ],
  dev: [
    "adam@mavenmm.com",
    "rondie@mavenmm.com",
    "chang@mavenmm.com",
  ],
};

// Category-level restrictions
// Categories not listed here are accessible to everyone
export const CATEGORY_ACCESS: Record<string, string[]> = {
  Admin: ["admin", "dev"],
  Dev: ["dev"],
};

// Per-app overrides (takes precedence over category)
// Use app ID as key
export const APP_ACCESS: Record<string, string[]> = {
  // Example: "10": ["admin", "leadership"],
};
